export type TMagtekDevice = {
  device_serial_number: string;
  display_message: string;
  status: number;
};

export const MagtekStatusDevice = {
  active: 1,
  inactive: 0,
};

export type TResponseMagtekDevice = {
  data: TMagtekDevice;
};

export enum MethodMagTek {
  START_EVM_TRANSACTION = 'start_evm_transaction',
  CANCEL_EVM_TRANSACTION = 'cancel_evm_transaction',
  NATIVE_DEVICE_CONNECTION_STATE = 'native_device_connection_state',
}

export enum TransactionMagTek {
  NATIVE_PAYMENT_NOTIFICATION = 'native_payment_notification',
}

export enum StepChargeMagTek {
  PRESENT_CARD = 'present_card',
  PAYMENT_PROCESSING = 'payment_processing',
  INSERT_CARD = 'insert_card',
  REMOVE_CARD_SUCCESSFUL = 'remove_card_successful',
  REMOVE_CARD_FAILED = 'remove_card_failed',
  PAYMENT_FAILED = 'payment_failed',
  PAYMENT_SUCCESS = 'payment_success',
}

export enum ActionChargeMagtek {
  TAP = 'tap',
  SWIPE = 'swipe',
  INSERT = 'insert',
}

export type TResponseCardData<T> = {
  data: T;
};

export type TCardData = {
  arqc: string;
  device_serial_number: string;
  action: string;
  card_holder_name: string;
  card_type: string;
  card_exp_date: string;
  is_timeout: number;
  is_cancel: number;
  dfdf25: string;
  dfdf30: string;
  dfdf31: string;
  dfdf32: string;
  dfdf33: string;
  dfdf34: string;
  dfdf52: string;
  dfdf53: string;
  dfdf54: string;
  dfdf55: string;
  dfdf56: string;
  dfdf57: string;
  dfdf58: string;
  dfdf59: string;
  m9f02: string;
  m9f03: string;
  m9f06: string;
  m9f12: string;
  f7: string;
  f8: string;
  f9: string;
  fa: string;
  f0: string;
  f1: string;
  dfdf1a: string;
  dfdf1b: string;
  m5f2a: string;
  m9f1c: string;
  m9f39: string;
  m9c: string;
  m9f34: string;
  m9f57: string;
  dfdf4d: string;
  m5f20: string;
};

export type TInputCardInformation = {
  card_expiration_date?: string;
  card_holder_name?: string;
  card_type?: string;
  card_first_six?: string;
  card_last_four?: string;
  card_zip_code?: string;
};

export type TResponseTransaction<T> = {
  data: T;
  type: TransactionMagTek;
};

export type TTransactionCardData = {
  message: string;
};

export type TPaymentFailed = {
  error: string;
  type: 'timeout' | 'canceled' | 'no_data';
};
